module.exports = __webpack_public_path__ + "static/media/close_clinic.a8540a7a.jpg";